import { updateHeaders } from 'utils/axios';
import { Response } from '../../models/Response';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { authenticationAction, LoginResp, loginThunk } from '../../redux/slices/authentication';
import storageService, { Locals } from '../../utils/storageService';

const useAuth = () => {
    const dispatch = useAppDispatch();

    const { authorizations, fetching, user } = useAppSelector((state) => state.authentication);
    const isLoggedIn = !!storageService.getItem(Locals.ACCESS_TOKEN);

    const initAuthData = (accessToken: string) => {
        updateHeaders(accessToken);
    };

    const login = (email: string, password: string): Promise<Response<LoginResp>> => {
        return dispatch(loginThunk({ email, password }))
            .unwrap()
            .then((data) => {
                initAuthData(data.getFirstData().access_token);
                return data;
            });
    };

    const logout = () => {
        storageService.removeItem(Locals.ACCESS_TOKEN);
        dispatch(authenticationAction.logout());
    };

    return {
        isLoggedIn,
        authorizations,
        fetching,
        user,
        login,
        logout,
        initAuthData,
    };
};

export default useAuth;
